import {IDartsTournament} from "../TournamentsCRUD.types";

export const getSortedTournaments = (tournaments: IDartsTournament[] = []) => {
    return [...tournaments].sort((a, b) =>
        (new Date(b?.dateStart).getTime() || 0) - (new Date(a?.dateStart).getTime() || 0)
    );
};